(() => {
  const productRoot = document.querySelector('product-info[id^="MainProduct-"]');
  if (!productRoot || productRoot.dataset.rpStickyRuntimeBound === 'true') return;

  const mediaViewport = productRoot.querySelector('[data-rp-sticky-media-viewport]');
  const stickyColumn = productRoot.querySelector('.product__media-wrapper[data-rp-sticky-column="media"]');
  if (!stickyColumn) return;

  productRoot.dataset.rpStickyRuntimeBound = 'true';
  const desktop = window.matchMedia('(min-width: 990px)');
  let destroyed = false;
  let frame = 0;
  const unsubscribers = [];

  const getHeaderOffset = () => {
    const candidates = document.querySelectorAll('sticky-header, .section-header, .announcement-bar-section');
    let bottom = 0;
    candidates.forEach((element) => {
      const rect = element.getBoundingClientRect();
      const style = window.getComputedStyle(element);
      if (rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden' && (style.position === 'fixed' || style.position === 'sticky')) {
        bottom = Math.max(bottom, rect.bottom);
      }
    });
    return Math.max(16, Math.ceil(bottom + 16));
  };

  const sync = () => {
    frame = 0;
    if (destroyed || !productRoot.isConnected || !stickyColumn.isConnected) return;

    const offset = getHeaderOffset();
    productRoot.style.setProperty('--rp-product-sticky-offset', `${offset}px`);
    const enabled = desktop.matches;
    stickyColumn.classList.toggle('rp-sticky-disabled', !enabled);
  };

  const scheduleSync = () => {
    if (frame || destroyed) return;
    frame = window.requestAnimationFrame(sync);
  };

  const onScroll = scheduleSync;
  const onResize = scheduleSync;
  const onMediaChange = scheduleSync;
  const onSectionLoad = (event) => {
    if (event.target?.contains?.(productRoot) || event.target === productRoot) scheduleSync();
  };
  const onSectionUnload = (event) => {
    if (event.target === productRoot || event.target?.contains?.(productRoot)) destroy();
  };

  const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(scheduleSync) : null;
  resizeObserver?.observe(productRoot);
  resizeObserver?.observe(stickyColumn);
  if (mediaViewport) {
    resizeObserver?.observe(mediaViewport);
    mediaViewport.querySelectorAll('.product__media-item, .thumbnail-slider').forEach((element) => resizeObserver?.observe(element));
  }

  const mutationObserver = typeof MutationObserver === 'function' && mediaViewport
    ? new MutationObserver(scheduleSync)
    : null;
  mutationObserver?.observe(mediaViewport, { attributes: true, childList: true, subtree: true });

  const destroy = () => {
    if (destroyed) return;
    destroyed = true;
    if (frame) window.cancelAnimationFrame(frame);
    resizeObserver?.disconnect();
    mutationObserver?.disconnect();
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onResize);
    desktop.removeEventListener?.('change', onMediaChange);
    document.removeEventListener('shopify:section:load', onSectionLoad);
    document.removeEventListener('shopify:section:unload', onSectionUnload);
    unsubscribers.splice(0).forEach((unsubscribe) => unsubscribe?.());
    delete productRoot.dataset.rpStickyRuntimeBound;
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize, { passive: true });
  desktop.addEventListener?.('change', onMediaChange);
  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('shopify:section:unload', onSectionUnload);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    if (PUB_SUB_EVENTS.variantChange) unsubscribers.push(subscribe(PUB_SUB_EVENTS.variantChange, scheduleSync));
    if (PUB_SUB_EVENTS.cartError) unsubscribers.push(subscribe(PUB_SUB_EVENTS.cartError, scheduleSync));
  }

  sync();
})();
